import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuraMark } from "@/components/site/AuraMark";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setUser(data);
        navigate("/area-membri", { replace: true, state: { user: data } });
      } catch {
        setUser(false);
        navigate("/accedi", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#050713]" data-testid="auth-callback">
      <AuraMark className="w-14 h-14 animate-pulse" />
    </div>
  );
}
